import { InjectionToken } from '@angular/core';
import { Environment } from '@thiememeulenhoff/types';

export interface ApiGatewayConfig {
  environment: Environment;
}

export const API_CONFIG = new InjectionToken<ApiGatewayConfig>('API_CONFIG');
